import { useEffect, useState } from 'react';
import { adminAPI } from '@/lib/api';
import { formatInt, formatMoney } from '@/lib/format';

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { adminAPI.stats().then(setS).catch(() => {}); }, []);
  if (!s) return <div className="text-zinc-500 font-mono text-sm">LOADING STATS…</div>;
  return (
    <div className="space-y-6">
      <div>
        <div className="label-sm mb-2">Admin overview</div>
        <h1 className="font-display text-3xl">Operations at a glance</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat k="Users" v={formatInt(s.users_count)} />
        <Stat k="Traders" v={formatInt(s.traders)} />
        <Stat k="Accounts" v={formatInt(s.accounts)} />
        <Stat k="Funded" v={formatInt(s.funded)} />
        <Stat k="Breached" v={formatInt(s.breached)} tone="red" />
        <Stat k="Pending rewards" v={formatInt(s.pending_payouts)} tone="yellow" />
        <Stat k="Pending Phase 2" v={formatInt(s.pending_phase_2 || 0)} tone="yellow" />
        <Stat k="Pending Funded" v={formatInt(s.pending_funded || 0)} tone="yellow" />
        <Stat k="Pending aff. rewards" v={formatInt(s.pending_affiliate_payouts)} tone="yellow" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 card-tech rounded-lg p-6">
          <div className="label-sm">Total evaluation fees collected</div>
          <div className="font-mono text-4xl mt-2">${formatMoney(s.revenue_usd)}</div>
        </div>
        <div className="card-tech rounded-lg p-6">
          <div className="label-sm">Active simulated size</div>
          <div className="font-mono text-3xl mt-2" data-testid="active-simulated-size">${formatInt(s.active_account_size_sum || 0)}</div>
          <div className="text-xs text-zinc-500 mt-1">Excludes breached accounts</div>
        </div>
      </div>
    </div>
  );
}

function Stat({ k, v, tone }) {
  const color = tone === 'red' ? 'text-[#ff3366]' : tone === 'yellow' ? 'text-[#ffcc00]' : 'text-white';
  return (
    <div className="card-tech rounded-lg p-4">
      <div className="label-xs">{k}</div>
      <div className={`font-mono text-2xl mt-1 ${color}`}>{v}</div>
    </div>
  );
}
